import { render, staticRenderFns } from "./partyb.vue?vue&type=template&id=34478bb8&scoped=true&"
import script from "./partyb.vue?vue&type=script&lang=js&"
export * from "./partyb.vue?vue&type=script&lang=js&"
import style0 from "./partyb.vue?vue&type=style&index=0&id=34478bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34478bb8",
  null
  
)

export default component.exports